<template>
    <section>
        <div class="user-balance-btn" @click="emit('toggle-user-balance-popup')">
            <div class="user-balance-btn__left">
                <div class="user-balance-btn__user-icon">
                    <KasaIcon name="user" />
                </div>
            </div>
            <div class="user-balance-btn__right">
                <div class="user-balance-btn__balance-value">
                    Zůstatek: <span class="user-balance__bold">{{ balanceValueText }}</span>
                </div>
                <div class="user-balance-btn__balance-date-wrap">
                    Pouze do: <span class="user-balance-btn__balance-date">{{ balanceDateText }}</span>
                </div>
            </div>
        </div>
        <TransitionFade>
            <section v-show="userBalancePopupVisible" class="user-balance-popup">
                <a
                    href="/sazka-klub/moje-uctenky"
                    class="user-balance-popup__link"
                    type="button"
                    @click="myReceiptsClickHandler"
                    >Moje účtenky</a
                >
                <a href="/sazka-klub/nastaveni" class="user-balance-popup__link">Nastavení účtu</a>
                <a class="user-balance-popup__link btn-logout" @click="logoutClickHandler">Odhlásit se</a>
            </section>
        </TransitionFade>
    </section>
</template>

<script lang="ts" setup>
import { logoutService } from "@/account/services/login-services";
import KasaIcon from "@/components/shared/assets/kasa-icon.vue";
import { StringHelper } from "@/helpers/string-helper";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import { computed } from "vue";
import { PaperlessDatalayer } from "@/account/utils/analytics/paperless-datalayer";

const emit = defineEmits(["toggle-user-balance-popup"]);

const props = defineProps<{
    userBalancePopupVisible: boolean;
    withdrawableAmount: number;
    withdrawalExpiration?: string;
}>();

const logoutClickHandler = async () => {
    await logoutService();
};

const balanceValueText = computed(() => StringHelper.toCurrencyString(props.withdrawableAmount).replace(/ /g, ""));
const balanceDateText = computed(() =>
    props.withdrawalExpiration ? DateTimeUtils.formatDate(new Date(props.withdrawalExpiration)) : "-"
);

const myReceiptsClickHandler = () => {
    PaperlessDatalayer.openMyReceipts();
};
</script>
